import React from 'react'
import { connect } from 'react-redux'
import { Icon, Menu } from 'semantic-ui-react'

import { creditNoteBillingInvoice } from 'actions/billing'

class CreditNoteBillingInvoiceItem extends React.Component {
  handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const reason = window.prompt('Reason for credit note:')
    if (reason) this.props.credit(this.props.billingInvoice.id, reason)
  }

  render () {
    const { billingInvoice } = this.props
    const canCredit = ['issued', 'reminded', 'paid'].includes(billingInvoice.status) &&
                      !billingInvoice.creditNoteReferenceInvoiceId
    if (!canCredit) return null

    return (
      <Menu.Item onClick={this.handleClick} title="Issue credit note">
        <Icon name="undo"/>
      </Menu.Item>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  credit: (id, reason) => dispatch(creditNoteBillingInvoice(id, reason))
})

export default connect(null, mapDispatchToProps)(CreditNoteBillingInvoiceItem)
